module.exports = __webpack_public_path__ + "img/book.e3c654a8.svg";